import { contextService } from '../../base/contextService';
import { getLangText } from '../../services/langService';
import { LANG_ENUM } from '@umu/umu-lang-switch';
import { getPDFDomain } from '@umu/umu-util';
/**
 * 用来表示满级的level数值
 */
export const FULL_USER_LEVEL = 999;

/**
 * 用户等级， 判断是否满级
 * @param {int} level
 */
export function isFullUserLevel(level = 1) {
    return level === FULL_USER_LEVEL;
}

/**
 * 获取用户等级的文本展示形式
 * @param {*} level
 * @param {*} isText
 */
export function displayUserLevel(level = 1, isText: boolean = false) {
    if (isFullUserLevel(level)) {
        return getLangText('满级');
    }
    return isText ? getLangText('{$0}级').replace('{$0}', level + '') : 'LV.' + level;
}

// 返回两个颜色， primary 和 secondary ，为主要颜色和辅助颜色
// primary 是头像等级条的背景色、升级弹窗的等级文字颜色
// secondary 是头像等级条的文字颜色、升级弹窗的背景颜色
// isLabel 表示用在头像下方的 label，只当满级时颜色与其它是相反的，特殊处理一次
export function getUserLevelColorScheme(level: number, isLabel: boolean = false) {
    level = level || 1;
    const ret = {
        primary: '#3FAA34', // 绿色
        secondary: '#FFF',
        range: '1',
    };

    if (isFullUserLevel(level)) {
        if (isLabel) {
            ret.primary = '#292929'; // 黑色
            ret.secondary = '#FFBD2B'; // 金色
        } else {
            ret.primary = '#FFBD2B'; // 金色
            ret.secondary = '#292929'; // 黑色
        }
        ret.range = 'full';
    } else if (level >= 21) {
        ret.primary = '#FFBD2B'; // 金色
        ret.range = '21';
    } else if (level >= 11) {
        ret.primary = '#3F51B5'; // 蓝色
        ret.range = '11';
    }

    return ret;
}
